import { useState } from "react"

import { Icon, Input } from "semantic-ui-react"
import styled from "styled-components"

const StyledParagraph = styled.p`
  margin-top: 0px;
  margin-bottom: 15px;
  font-size: 13px;
  color: #2a2828;
  padding: 3px;
  padding-left: 6px;
  border-left: 4px solid #ffe4b5;
  background-color: #fffad1;
  display: block;
`

const NumericalText = ({ field, fieldValue = "", updateIdea, isEditing, inputRef, handleKeyDown }) => {
  const { minValue, maxValue } = field
  const [validEntry, setValidEntry] = useState(true)
  if (!isEditing) {
    return <span>{fieldValue} </span>
  }
  const isNumber = (value) => typeof value === "number" && Number.isFinite(value)

  let message = null
  if (isNumber(minValue) && isNumber(maxValue)) {
    message = `Enter a number between ${minValue} and ${maxValue}.`
  } else if (isNumber(minValue)) {
    message = `Enter a number greater than ${minValue}.`
  } else if (isNumber(maxValue)) {
    message = `Enter a number less than ${maxValue}.`
  }

  return (
    <div>
      {message && (
        <StyledParagraph>
          <Icon name="info circle" />
          {message}
        </StyledParagraph>
      )}

      <Input
        fluid
        value={fieldValue}
        onChange={(_e, { value }) => {
          const num = parseFloat(value)
          const isValidMin = !isNumber(minValue) || num >= minValue
          const isValidMax = !isNumber(maxValue) || num <= maxValue
          if (isValidMin && isValidMax) {
            setValidEntry(true)
          }
          updateIdea(num, ["templated", field.id])
        }}
        onBlur={(e) => {
          const num = parseFloat(e.target.value)
          const isValidMin = !isNumber(minValue) || num >= minValue
          const isValidMax = !isNumber(maxValue) || num <= maxValue
          setValidEntry(isValidMin && isValidMax)
        }}
        ref={inputRef}
        readOnly={!isEditing}
        type="number"
        error={!validEntry}
        onKeyDown={(event) => handleKeyDown(event)}
      />
    </div>
  )
}

export default NumericalText
